<template>
    <v-menu
        ref="menu"
        v-model="periodMenu"
        :close-on-content-click="false"
        :return-value.sync="period"
        transition="scale-transition"
        offset-y
        class="py-0"
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on">
                Perioada {{ periodText }}
            </v-btn>
        </template>
        <v-date-picker
            v-model.lazy="period"
            range
        >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="periodMenu = false"
            >
                Anulare
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.menu.save(period)"
            >
                Filtrare
            </v-btn>
        </v-date-picker>
    </v-menu>
</template>
<script>
    import debounce from 'lodash/debounce'
    export default {
        props: {
            value: {
                type: Array,
                default () {
                    return [window.moment().toISOString(), window.moment().toISOString()]
                }
            }
        },
        data: function () {
            return {
                period: this.value,
                periodMenu: false,
            }
        },
        watch: {
            period: {
                handler: debounce(function (val) {
                    if(val.length === 2) {
                        this.$emit('input', val)
                    }
                }, 500)
            }
        },
        computed: {
            periodText() {
                return this.period.map(item => this.$options.filters.date(new Date(item))).join(' ~ ')
            }
        }
    }
</script>
